import { render, staticRenderFns } from "./ScormRequests.vue?vue&type=template&id=46b62d16&"
import script from "./ScormRequests.vue?vue&type=script&lang=js&"
export * from "./ScormRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports